import { DISPOSE_STORE as DISPOSE_ACTION_TYPE } from './constants.tsx';

export const DISPOSE_ACTION = { type: DISPOSE_ACTION_TYPE } as const;
